import { render } from "./UserOrder.vue?vue&type=template&id=feb4e434"
import script from "./UserOrder.vue?vue&type=script&lang=js"
export * from "./UserOrder.vue?vue&type=script&lang=js"

import "./UserOrder.vue?vue&type=style&index=0&id=feb4e434&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__